import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IExpressSetupDto } from '@/dtos';

import { ExpressSetupDtoResponse } from '../ExpressSetup.types';

interface Data {
  dto: Partial<ExpressSetupDtoResponse>;
  successCallback?: () => void;
}

export const useUpdateExpressSetupByIdQuery = (id: string, errorCallback?: (error: unknown) => void) => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    ({ dto, successCallback }: Data) =>
      api.patch<IExpressSetupDto>(API_URL.EXPRESS_SETUPS_BY_ORGANIZATION_ID(id), dto).then((data) => {
        if (successCallback) {
          successCallback();
        }
        queryClient.invalidateQueries({
          queryKey: [API_URL.ACTIVITY_LOGS],
        });
        return data;
      }),
    {
      onError: (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    }
  );
  return mutation;
};

export default useUpdateExpressSetupByIdQuery;
